const dataDisabledAdded = "data-ux-disabled-added";
export const handleDisabledElements = (item, supportedElements, hide) => {
    const uxFormElements = Array.from(item.querySelectorAll(`${supportedElements.join(", ")}`));
    uxFormElements.forEach((uxFormElement) => {
        if (hide) {
            if (uxFormElement.hasAttribute("disabled")) {
                return;
            }
            uxFormElement.setAttribute(dataDisabledAdded, "");
            uxFormElement.setAttribute("disabled", "true");
        }
        else {
            if (!uxFormElement.hasAttribute(dataDisabledAdded)) {
                return;
            }
            uxFormElement.removeAttribute(dataDisabledAdded);
            uxFormElement.removeAttribute("disabled");
        }
    });
};
/** Returns an array with all the Ux Form elements present in the form */
export const getInputElements = ({ container, supportedElements }) => {
    const allUxInputElements = container.querySelectorAll(supportedElements.join(", "));
    const uxInputElements = Array.from(allUxInputElements);
    return uxInputElements.filter((uxInputElement) => {
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        // @ts-expect-error Check for typing
        return !uxInputElement.parentElement.closest("ux-form-group");
    });
};
export const getFormData = ({ uxElements }) => {
    const formData = {};
    uxElements.forEach((uxInputElement) => {
        const inputElements = Array.from(uxInputElement.querySelectorAll("input, select, textarea"));
        // @ts-expect-error Check for typing
        let inputValues = inputElements.map((inputElement) => {
            if (inputElement.type === "checkbox" || inputElement.type === "radio") {
                if (inputElement.checked) {
                    return inputElement.value;
                }
                else {
                    return "";
                }
            }
            else {
                return inputElement.value;
            }
        });
        // @ts-expect-error Check for typing
        const fileElements = inputElements.filter((inputElement) => {
            return inputElement.type === "file";
        });
        let files = null;
        if (fileElements.length < 1) {
            files = null;
        }
        else {
            // @ts-expect-error Check for typing
            files = fileElements.map((inputElement) => {
                // eslint-disable-next-line @stencil-community/strict-boolean-conditions
                if (inputElement.files.length) {
                    return inputElement.files;
                }
                else {
                    return null;
                }
            });
        }
        if (fileElements.length < 1) {
            // @ts-expect-error Check for typing
            formData[uxInputElement.name] = {
                values: inputValues
            };
        }
        else {
            inputValues = inputValues.length > 1 ? inputValues.filter((inputValue) => inputValue !== "") : inputValues;
            // @ts-expect-error Check for typing
            files = files.length > 1 ? files.filter((file) => file !== null) : files;
            // @ts-expect-error Check for typing
            formData[uxInputElement.name] = {
                values: inputValues,
                files: files
            };
        }
    });
    return formData;
};
export const getErrorMessageSetter = ({ uxInputElement, uxForm }) => (dataErrorMsg) => {
    uxInputElement.error = true;
    if (dataErrorMsg === null) {
        uxInputElement.errorMsg = "";
        return;
    }
    const errorMessage = uxInputElement.getAttribute(dataErrorMsg);
    const globalErrorMessage = uxForm.getAttribute(dataErrorMsg);
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    if (errorMessage || globalErrorMessage) {
        // @ts-expect-error Check for typing
        uxInputElement.errorMsg = errorMessage || globalErrorMessage;
    }
};
export const validateFormGroup = ({ uxElement, errorSetter, dataGroup, dataRequired }) => {
    const inputElements = Array.from(uxElement.querySelectorAll("input"));
    const checkedElement = inputElements.filter((inputElement) => inputElement.checked && inputElement.value !== "manage-all-checkboxes");
    const groupMin = uxElement.getAttribute(`${dataGroup}--min`);
    const groupMax = uxElement.getAttribute(`${dataGroup}--max`);
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    if (!uxElement.required && !groupMin && !groupMax) {
        return;
    }
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    if (checkedElement.length > 0 && !groupMin && !groupMax) {
        return;
    }
    if (groupMin && Number(groupMin) > checkedElement.length) {
        errorSetter(`${dataGroup}--msg`);
    }
    if (groupMax && Number(groupMax) < checkedElement.length) {
        errorSetter(`${dataGroup}--msg`);
    }
    if (checkedElement.length === 0) {
        errorSetter(`${dataRequired}--msg`);
    }
};
export const getValidationAttributes = ({ uxElement, dataLength, dataValue, dataRegex }) => {
    const minLength = uxElement.getAttribute(`${dataLength}--min`);
    const maxLength = uxElement.getAttribute(`${dataLength}--max`);
    const minValue = uxElement.getAttribute(`${dataValue}--min`);
    const maxValue = uxElement.getAttribute(`${dataValue}--max`);
    const regexExpression = uxElement.getAttribute(`${dataRegex}--expression`);
    const regexFlag = uxElement.getAttribute(`${dataRegex}--flag`);
    return {
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        minLength: !!minLength ? Number(minLength) : null,
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        maxLength: !!maxLength ? Number(maxLength) : null,
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        minValue: !!minValue ? Number(minValue) : null,
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        maxValue: !!maxValue ? Number(maxValue) : null,
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        regexExpression: !!regexExpression ? regexExpression : null,
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        regexFlag: !!regexFlag ? regexFlag : null
    };
};
//# sourceMappingURL=utils.js.map
